/**
 * Adds the promo_id link's promotion to search-room params, if one is active.
 * @param {Object} params search-room params
 * @param {String} promotionFilterId id from getBePromotionFilterId
 * @returns {Object} params, with promotion_affected when the filter is active
 */
export function withPromotionFilter(params, promotionFilterId) {
  if (!promotionFilterId) return params;
  return { ...params, promotion_affected: promotionFilterId };
}



// WEBPACK FOOTER //
// ./src/utils/bePromotionFilter.js